<template>
  <div id="DataDive">
    <div v-if="censusData && !aggArea_esri_format">
      <div style="font-weight: bold; font-size: medium"
           v-if="geotype === 'tracts' || geotype === 'blocks' || geotype === 'blockgroups'">
        {{ geotypes[geotype].name.slice(0, geotypes[geotype].name.length - 1) }}: {{ geoid }} in
        {{ $parent.regionBoundarys[censusData.semmcd].properties.name }}
      </div>
    </div>
    <div v-if="censusData && !aggArea_esri_format">
      <div style="font-weight: bold; font-size: medium"
           v-if="geotype === 'mcds'  ">
        {{ $parent.regionBoundarys[censusData.semmcd].properties.name }}
      </div>
      <div style="font-weight: bold; font-size: medium"
           v-if="geotype === 'schooldistricts'|| geotype === 'isds' || geotype === 'counties'">
        {{ censusData.geoname }}
      </div>
    </div>
    <div v-if="aggArea_esri_format">
      <div style="font-weight: bold; font-size: medium">Aggregation from sketch</div>
    </div>
    <hr v-if="censusData">
    <div v-if="censusData" style="">
      <table>
        <tr>
          <th class="columnname">2020 Census Demographics</th>
          <th class="columnname" style="text-align: end;"></th>
        </tr>
        <tr>
          <th><strong>Total Population</strong></th>
          <td><strong>{{ format(censusData.pop_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Group Quarters Population</th>
          <td> {{ format(censusData.gq_pop) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Ages 0-17 Population</th>
          <td> {{ format(censusData.age00_17) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Ages 18+ Population</th>
          <td> {{ format(censusData.age18_up) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Non-Hispanic Population</th>
          <td> {{ format(censusData.nh_tot) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">White Population</th>
          <td> {{ format(censusData.nh_white) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Black Population</th>
          <td> {{ format(censusData.nh_black) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Asian Population</th>
          <td> {{ format(censusData.nh_asian) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Multi Race Population</th>
          <td> {{ format(censusData.nh_multi) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Other Race Population</th>
          <td> {{ format(censusData.nh_other) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Hispanic Population</th>
          <td> {{ format(censusData.hispanic) }}</td>
        </tr>

        <tr>
          <th><strong>Households</strong></th>
          <td><strong>{{ format(censusData.hh_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Household Size</th>
          <td>{{ formatDec(censusData.hh_size) }}</td>
        </tr>
        <tr>
          <th><strong>Housing Units</strong></th>
          <td><strong>{{ format(censusData.hu_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Vacant Units</th>
          <td>{{ format(censusData.hu_vac) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Vacancy Rate</th>
          <td>{{ formatPct(censusData.vac_rate) }}</td>
        </tr>

      </table>
    </div>
    <hr v-if="censusSpatialData">
    <div v-if="censusSpatialData" style="">
      <table>
        <tr>
          <th class="columnname">2020 Census Demographics</th>
          <th class="columnname" style="text-align: end;"></th>
        </tr>
        <tr>
          <th><strong>Total Population</strong></th>
          <td><strong>{{ format(censusSpatialData.pop_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Group Quarters Population</th>
          <td> {{ format(censusSpatialData.gq_pop) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Ages 0-17 Population</th>
          <td> {{ format(censusSpatialData.age00_17) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Ages 18+ Population</th>
          <td> {{ format(censusSpatialData.age18_up) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Non-Hispanic Population</th>
          <td> {{ format(censusSpatialData.nh_tot) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">White Population</th>
          <td> {{ format(censusSpatialData.nh_white) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Black Population</th>
          <td> {{ format(censusSpatialData.nh_black) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Asian Population</th>
          <td> {{ format(censusSpatialData.nh_asian) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Multi Race Population</th>
          <td> {{ format(censusSpatialData.nh_multi) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 35px">Other Race Population</th>
          <td> {{ format(censusSpatialData.nh_other) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Hispanic Population</th>
          <td> {{ format(censusSpatialData.hispanic) }}</td>
        </tr>

        <tr>
          <th><strong>Households</strong></th>
          <td><strong>{{ format(censusSpatialData.hh_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Household Size</th>
          <td>{{ formatDec(censusSpatialData.hh_size) }}</td>
        </tr>
        <tr>
          <th><strong>Housing Units</strong></th>
          <td><strong>{{ format(censusSpatialData.hu_tot) }}</strong></td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Vacant Units</th>
          <td>{{ format(censusSpatialData.hu_vac) }}</td>
        </tr>
        <tr>
          <th style="padding-left: 20px">Vacancy Rate</th>
          <td>{{ formatPct(censusSpatialData.vac_rate) }}</td>
        </tr>

      </table>
    </div>
    <span style="margin-left: 10px" class="">
            <a v-if="geotype === 'mcds' || geotype === 'counties'"
               v-bind:href="CPLink(geoid)"
               v-bind:title="'View Community Profile Page'"
               style="white-space: nowrap;"><small>Link to: </small><img style="width: 18px;" src="images/region.svg"
                                                                         alt=""> Community Profile
            </a>
          </span>
  </div>
</template>

<script>
import * as d3 from "d3";
import {queryFeatures} from "@esri/arcgis-rest-feature-service";

export default {
  name: "DataDive",
  props: ["geoid", "aggArea_esri_format", "geotype", "geotypes", "censusFeatureLayerUrl"],
  data: function () {
    return {
      censusData: null,
      censusSpatialData: null,
    }
  },
  computed: {
  },
  methods: {
    format: d3.format(',d'),
    formatDec: d3.format('.2f'),
    formatPct: d3.format('0.1%'),
    getDataSummary: function () {
      let geoids = '1=1'
      if (Array.isArray(this.geoid) && this.geoid.length !== 0) {
        geoids = `semgeoid IN (${this.geoid.join(',')})`;
      } else if (this.geoid && this.geoid !== 0) {
        geoids = `semgeoid = ${this.geoid}`
      }
      this.censusData = null
      queryFeatures({
        url: this.censusFeatureLayerUrl,
        where: geoids,
        httpMethod: 'POST',
        outStatistics: [
          {
            onStatisticField: 'geoname',
            statisticType: 'min',
            outStatisticFieldName: 'geoname',
          }, {
            onStatisticField: 'semmcd',
            statisticType: 'min',
            outStatisticFieldName: 'semmcd',
          },
          {
            onStatisticField: 'pop_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'pop_tot',
          },
          {
            onStatisticField: 'gq_pop',
            statisticType: 'sum',
            outStatisticFieldName: 'gq_pop',
          }, {
            onStatisticField: 'age00_17',
            statisticType: 'sum',
            outStatisticFieldName: 'age00_17',
          }, {
            onStatisticField: 'age18_up',
            statisticType: 'sum',
            outStatisticFieldName: 'age18_up',
          }, {
            onStatisticField: 'nh_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_tot',
          }, {
            onStatisticField: 'nh_white',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_white',
          }, {
            onStatisticField: 'nh_black',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_black',
          }, {
            onStatisticField: 'nh_asian',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_asian',
          }, {
            onStatisticField: 'nh_multi',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_multi',
          }, {
            onStatisticField: 'nh_other',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_other',
          }, {
            onStatisticField: 'hispanic',
            statisticType: 'sum',
            outStatisticFieldName: 'hispanic',
          }, {
            onStatisticField: 'hh_pop',
            statisticType: 'sum',
            outStatisticFieldName: 'hh_pop',
          },
          {
            onStatisticField: 'hh_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'hh_tot',
          }, {
            onStatisticField: 'hu_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'hu_tot',
          }, {
            onStatisticField: 'hu_vac',
            statisticType: 'sum',
            outStatisticFieldName: 'hu_vac',
          },
        ]
      }).then((results) => {
        let out = {}
        let r = results.features[0].attributes
        out['geoname'] = r.geoname
        out['semmcd'] = r.semmcd
        out['pop_tot'] = r.pop_tot
        out['gq_pop'] = r.gq_pop
        out['age00_17'] = r.age00_17
        out['age18_up'] = r.age18_up
        out['nh_tot'] = r.nh_tot
        out['nh_white'] = r.nh_white
        out['nh_black'] = r.nh_black
        out['nh_asian'] = r.nh_asian
        out['nh_multi'] = r.nh_multi
        out['nh_other'] = r.nh_other
        out['hispanic'] = r.hispanic
        out['hh_tot'] = r.hh_tot
        out['hu_tot'] = r.hu_tot
        out['hu_vac'] = r.hu_vac
        out['vac_rate'] = r.hu_vac / r.hu_tot
        out['hh_size'] = r.hh_pop / r.hh_tot
        this.censusData = out
        this.censusSpatialData = null
      })
    },
    getSpatialDataSummary: function () {
      this.censusSpatialData = null
      queryFeatures({
        url: this.censusFeatureLayerUrl,
        where: this.filter,
        geometry: this.aggArea_esri_format,
        geometryType: "esriGeometryPolygon",
        spatialRel: "esriSpatialRelIntersects",
        httpMethod: 'POST',
        outStatistics: [
          {
            onStatisticField: 'geoname',
            statisticType: 'min',
            outStatisticFieldName: 'geoname',
          }, {
            onStatisticField: 'semmcd',
            statisticType: 'min',
            outStatisticFieldName: 'semmcd',
          },
          {
            onStatisticField: 'pop_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'pop_tot',
          },
          {
            onStatisticField: 'gq_pop',
            statisticType: 'sum',
            outStatisticFieldName: 'gq_pop',
          }, {
            onStatisticField: 'age00_17',
            statisticType: 'sum',
            outStatisticFieldName: 'age00_17',
          }, {
            onStatisticField: 'age18_up',
            statisticType: 'sum',
            outStatisticFieldName: 'age18_up',
          }, {
            onStatisticField: 'nh_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_tot',
          }, {
            onStatisticField: 'nh_white',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_white',
          }, {
            onStatisticField: 'nh_black',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_black',
          }, {
            onStatisticField: 'nh_asian',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_asian',
          }, {
            onStatisticField: 'nh_multi',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_multi',
          }, {
            onStatisticField: 'nh_other',
            statisticType: 'sum',
            outStatisticFieldName: 'nh_other',
          }, {
            onStatisticField: 'hispanic',
            statisticType: 'sum',
            outStatisticFieldName: 'hispanic',
          }, {
            onStatisticField: 'hh_pop',
            statisticType: 'sum',
            outStatisticFieldName: 'hh_pop',
          },
          {
            onStatisticField: 'hh_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'hh_tot',
          }, {
            onStatisticField: 'hu_tot',
            statisticType: 'sum',
            outStatisticFieldName: 'hu_tot',
          }, {
            onStatisticField: 'hu_vac',
            statisticType: 'sum',
            outStatisticFieldName: 'hu_vac',
          },
        ]
      }).then((results) => {
        let out = {}
        let r = results.features[0].attributes
        out['geoname'] = r.geoname
        out['semmcd'] = r.semmcd
        out['pop_tot'] = r.pop_tot
        out['gq_pop'] = r.gq_pop
        out['age00_17'] = r.age00_17
        out['age18_up'] = r.age18_up
        out['nh_tot'] = r.nh_tot
        out['nh_white'] = r.nh_white
        out['nh_black'] = r.nh_black
        out['nh_asian'] = r.nh_asian
        out['nh_multi'] = r.nh_multi
        out['nh_other'] = r.nh_other
        out['hispanic'] = r.hispanic
        out['hh_tot'] = r.hh_tot
        out['hu_tot'] = r.hu_tot
        out['hu_vac'] = r.hu_vac
        out['vac_rate'] = r.hu_vac / r.hu_tot
        out['hh_size'] = r.hh_pop / r.hh_tot
        this.censusSpatialData = out
        this.censusData = null
      })
    },
    CPLink: function (geoid) {
      if (geoid && this.geotype === 'mcds') {
        return 'https://data.semcog.org/community-profiles?mcd=' + geoid
      } else if (geoid && this.geotype === 'counties') {
        return this.countyIdLookup(geoid)
      } else {
        return 'https://data.semcog.org/community-profiles'
      }
    },
    countyIdLookup: function (id) {
      let ids = {
        93: 'https://data.semcog.org/community-profiles?mcd=7005,7010,7015,7020,7025,7027,7030,7035,7040,7045,7050,7055,7060,7065,7070,7075,7080,7085,7090,7095,7100&counties=93',
        99: 'https://data.semcog.org/community-profiles?mcd=3005,3010,3015,3020,3025,3030,3035,3040,3045,3050,3055,3060,3065,3070,3075,3080,3085,3090,3095,3100,3105,3110,3115,3120,3125,3130,3135&counties=99',
        115: 'https://data.semcog.org/community-profiles?mcd=5005,5010,5015,5020,5025,5030,5035,5040,5045,5047,5050,5055,5060,5065,5070,5075,5080,5085,5090,5095,5100,5105,5110,5115,5120&counties=115',
        125: 'https://data.semcog.org/community-profiles?mcd=2005,2010,2015,2020,2025,2030,2035,2040,2045,2050,2055,2060,2065,2072,2073,2075,2080,2085,2090,2095,2100,2105,2110,2115,2120,2125,2130,2135,2140,2145,2150,2155,2160,2165,2170,2172,2175,2180,2185,2190,2195,2200,2205,2210,2215,2220,2230,2235,2240,2245,2250,2252,2255,2260,2265,2270,2275,2280,2285,2290,2295,2300&counties=125',
        147: 'https://data.semcog.org/community-profiles?mcd=6005,6010,6015,6020,6025,6030,6035,6040,6045,6050,6055,6060,6065,6070,6075,6080,6085,6090,6095,6100,6105,6110,6115,6120,6125,6135,6140,6142,6145,6150,6155,6160,6165&counties=147',
        161: 'https://data.semcog.org/community-profiles?mcd=4005,4010,4015,4018,4020,4025,4030,4035,4040,4045,4050,4055,4060,4065,4070,4075,4080,4085,4090,4095,4100,4105,4110,4115,4120,4125,4130,4135&counties=161',
        163: 'https://data.semcog.org/community-profiles?mcd=5,1005,1010,1015,1020,1025,1030,1040,1045,1050,1055,1060,1065,1070,1075,1080,1085,1090,1095,1100,1105,1110,1115,1120,1125,1130,1135,1140,1145,1150,1155,1160,1165,1170,1175,1180,1185,1190,1200,1205,1210,1215,1220&counties=163',
      }
      return ids[id] || id || 8999
    },
  },
  watch: {
    geotype: {
      immediate: true,
      handler: function () {
        this.getDataSummary()
        if (this.aggArea_esri_format) {
          this.getSpatialDataSummary()
        }
      }
    },
    geoid: {
      immediate: true,
      handler: function () {
        this.getDataSummary()
      }
    },
    aggArea_esri_format: function () {
      this.getSpatialDataSummary()
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th {
  background: #ffffff;
  border-bottom: 1px black solid;
  font-size: small;
  padding-left: 4px;
  max-width: 350px;
  font-weight: unset;
}

td {
  background: #ffffff;
  border-bottom: 1px black solid;
  font-size: small;
  text-align: end;
}

div#DataDive {
  overflow: auto;
  max-height: 25vh;
}

.columnname {
  font-weight: bolder;
  font-size: medium;
}
</style>
